import { Field, Input, Title1, Toolbar, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import React, { useContext, useEffect, useState } from 'react';
import MasterTable from '../parts/master/MasterTable';
import { Master } from '../library/CosmeWidgetAPIClient';
import PageLoading from '../parts/PageLoading';
import { CWClientContext } from '../App';
import FileUpload from '../parts/master/FileUpload';
import FileDownload from '../parts/master/FileDownload';


const useStyles = makeStyles({
    toolbar: {
        ...shorthands.borderBottom("1px solid"),
        backgroundColor: tokens.colorNeutralBackground1,
    },
    filterGroup: {
        display: "flex",
        gridRowGap: tokens.spacingVerticalS,
    },
});

/*
*
*/
function MasterPage() {
    const cwClient = useContext(CWClientContext);
    const styles = useStyles();

    const [masters, setMasters] = useState<Master[]>([]);
    const [makerInput, setMakerInput] = useState("");
    const [brandInput, setBrandInput] = useState("");
    const [itemInput, setItemInput] = useState("");
    const [colorInput, setColorInput] = useState("");

    const searchMaster = () => {
        (async () => {
            const m = await cwClient.searchMaster(makerInput + ' ' + brandInput + ' ' + itemInput + ' ' + colorInput
                , 200, 0
            );
            setMasters(m);
        })();
    }

    useEffect(() => {
        searchMaster();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        searchMaster();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [makerInput, brandInput, itemInput, colorInput]);

    if (masters === undefined) {
        return (

            <PageLoading
                message='元帳を読み込んでいます'
            />
        );
    }

    return (
        <>
            <Title1>元帳管理</Title1>
            <Toolbar className={styles.toolbar}
                aria-label="Medium"
                size="small"
                style={{
                    border: "2px solid lightgrey",
                    borderRadius: "4px",
                }}
            >

                <FileUpload
                    buttonContent="元帳アップロード"
                    dialogTitle="元帳アップロード"
                ></FileUpload>

                <FileDownload
                    buttonContent="元帳ダウンロード"
                    dialogTitle="元帳ダウンロード"
                ></FileDownload>


                <ToolbarDivider></ToolbarDivider>
                <ToolbarGroup
                    className={styles.filterGroup}
                >
                    絞りこみ
                    <Field
                        size="medium"
                        label="メーカー名"
                    >
                        <Input
                            value={makerInput}
                            onChange={(e, data) => {
                                setMakerInput(data?.value);
                            }}
                        ></Input>
                    </Field>

                    <Field
                        size="medium"
                        label="ブランド名"
                    >
                        <Input
                            value={brandInput}
                            onChange={(e, data) => {
                                setBrandInput(data?.value);
                            }}
                        ></Input>
                    </Field>
                    <Field
                        size="medium"
                        label="商品名"
                    >
                        <Input
                            value={itemInput}
                            onChange={(e, data) => {
                                setItemInput(data?.value);
                            }}
                        ></Input>
                    </Field>
                    <Field
                        size="medium"
                        label="色番"
                    >
                        <Input
                            value={colorInput}
                            onChange={(e, data) => {
                                setColorInput(data?.value);
                            }}
                        ></Input>
                        
                    </Field>

                </ToolbarGroup>
            </Toolbar>
            <MasterTable
                masters={masters}
                setMasters={setMasters}
            />
        </>
    );
}
export default MasterPage;